import { Check, Sparkle } from "@phosphor-icons/react";

export default function PlanCard({ plan, active, loading, onSelect }) {
  return (
    <div
      className={[
        "zx-card relative flex h-full flex-col justify-between p-5",
        plan.popular ? "ring-1 ring-[rgba(184,50,90,0.55)]" : "",
      ].join(" ")}
      data-testid={`plan-card-${plan.id}`}
    >
      {plan.popular && (
        <span className="absolute -top-2 right-4 flex items-center gap-1 rounded-full bg-[#8B1E3F] px-3 py-1 text-[9px] uppercase tracking-[0.22em] text-[#f5f5f5]">
          <Sparkle size={10} weight="fill" /> Popular
        </span>
      )}
      <div>
        <div className="flex items-center justify-between gap-2">
          <p className="zx-label">{plan.key || plan.id}</p>
          {plan.status === "inactive" && (
            <span className="rounded-full border border-[rgba(255,255,255,0.15)] px-2 py-0.5 text-[9px] uppercase tracking-[0.18em] text-[rgba(255,255,255,0.45)]">
              Inactivo
            </span>
          )}
        </div>
        <h3 className="font-serif text-3xl tracking-tight text-[#f5f5f5]">
          {plan.name}
        </h3>
        {plan.description && plan.features?.length === 1 && plan.features[0] === plan.description ? (
          <p className="mt-2 text-sm text-[rgba(255,255,255,0.65)]">{plan.description}</p>
        ) : null}
        <div className="mt-3 flex items-baseline gap-1">
          <span className="font-serif text-4xl text-[#f5f5f5]">
            {plan.price === 0 ? "Gratis" : `€${plan.price.toFixed(2)}`}
          </span>
          {plan.price > 0 && (
            <span className="text-[10px] uppercase tracking-[0.22em] text-[rgba(255,255,255,0.55)]">
              / {plan.period}
            </span>
          )}
        </div>

        <ul className="mt-5 space-y-2">
          {plan.features.map((f) => (
            <li
              key={f}
              className="flex items-start gap-2 text-sm text-[rgba(255,255,255,0.75)]"
            >
              <Check size={14} weight="thin" className="mt-1 text-[#e9b5c5]" />
              <span>{f}</span>
            </li>
          ))}
        </ul>
      </div>

      <button
        onClick={onSelect}
        disabled={active || loading}
        className={[
          "mt-6 w-full rounded-full px-5 py-3 text-[11px] uppercase tracking-[0.22em] transition-all",
          active
            ? "cursor-default border border-[rgba(255,255,255,0.12)] bg-transparent text-[rgba(255,255,255,0.5)]"
            : "bg-[#8B1E3F] text-[#f5f5f5] hover:bg-[#B8325A]",
        ].join(" ")}
        data-testid={`plan-select-${plan.id}`}
      >
        {active ? "Plan actual" : loading ? "Procesando..." : "Elegir"}
      </button>
    </div>
  );
}
